<template>
  <div v-if="groupActionTrackers.length > 0">
    <div class="col-sm-4 col-md-4 col-lg-4">
      <div class="list-group action-list-group">
        <button class="list-group-item" style="width: 100%; text-align: left;" @click="open = true">
          <i class="mdi mdi-progress-download list-btn btn-primary"></i> Groepsacties statussen openen
        </button>
      </div>
    </div>
    <a-modal v-model="open">
      <a-list>
        <a-list-item :key="tracker.id" v-for="tracker in getActiveTrackers"
                     style="display:flex; flex-direction: column; align-items:flex-start;"
        >
          <a-list-item-meta>
            <span slot="title">
              {{ tracker.group_action_title }}
            </span>
          </a-list-item-meta>
          <a-progress
              :percent="Math.round(100 * (tracker.processed_count / tracker.count))"
              style="margin-top:1em;margin-bottom: 1em;"
          ></a-progress>
          <div>
            Totaal: {{ tracker.count }}
            <a-divider type="vertical"/>
            Gefaald: {{ tracker.failed_count }}
            <a-divider type="vertical"/>
            Behandeld: {{ tracker.processed_count }}
          </div>
          <div style="margin-top: 1em;">
            <a-button size="small" type="secondary"
                      v-if="!showFailedJobs.includes(tracker.id)"
                      @click="showFailedJobs.push(tracker.id)">
              gefaald
            </a-button>
            <a-button size="small" type="secondary"
                      v-if="showFailedJobs.includes(tracker.id)"
                      @click="showFailedJobs.splice(showFailedJobs.indexOf(tracker.id),1)">
              verbergen
            </a-button>
          </div>
          <div v-if="showFailedJobs.includes(tracker.id)" style="max-height: 400px; overflow:auto; width: 100%;">
            <ul>
              <li v-for="id in tracker.class_ids_for_failed_actions">
                <a :href="`/web_api/v1/group_action/${tracker.action_type}/link/${id}`">
                  {{ id }}
                </a>
              </li>
            </ul>
          </div>
        </a-list-item>
        <a-list-item :key="tracker.id" v-for="tracker in getFinishedTrackers" style="flex-direction: column;">
          <a-list-item-meta>
            <div slot="title"
                 style="display:flex;flex-direction: row;justify-content: space-between; align-items: center;">
              {{ tracker.group_action_title }}
              <div>
                <a-button
                    size="small" type="secondary"
                    @click="showFailedJobs.push(tracker.id)"
                    v-if="!showFailedJobs.includes(tracker.id)"
                >
                  gefaald
                </a-button>
                <a-button
                    size="small" type="secondary"
                    v-if="showFailedJobs.includes(tracker.id)"
                    @click="showFailedJobs.splice(showFailedJobs.indexOf(tracker.id),1)"
                >
                  verbergen
                </a-button>
              </div>
              <a-alert message="Afgerond" type="success" show-icon/>
            </div>
          </a-list-item-meta>
          <div v-if="showFailedJobs.includes(tracker.id)" style="max-height: 400px; overflow:auto; width: 100%;">
            <ul>
              <li v-for="id in tracker.class_ids_for_failed_actions" v-if="tracker.hasOwnProperty('class_ids_for_failed_actions')">
                <a :href="`/web_api/v1/group_action/${tracker.action_type}/link/${id}`">
                  {{ id }}
                </a>
              </li>
            </ul>
          </div>
        </a-list-item>
      </a-list>
      <template slot="footer">
        <a-button key="back" @click="open = false">
          Cancel
        </a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import groupActionApi from '~/api/group_action.js';

export default {
  props: {
    searchId: Number
  },
  data() {
    return {
      open: false,
      groupActionTrackers: [],
      loadingGroupActionTrackers: false,
      descriptions: {
        car: {
          title: 'Autoverzekeringen vergelijken'
        },
        death: {
          title: 'Overlijdensrisicoverzekering vergelijken'
        },
        mortgage: {
          title: 'Hypotheken herfinanciering vergelijken'
        }
      },
      showFailedJobs: []
    }
  },
  async mounted() {
    await this.fetchGroupActionTrackers();
    this.initializePusher();
  },
  methods: {
    async fetchGroupActionTrackers() {
      if (!this.searchId) return;

      this.loadingGroupActionTrackers = true;
      try {
        let response = await groupActionApi.getGroupActionTrackers(this.searchId);
        this.groupActionTrackers = response.data;
      } catch (e) {
        this.$notification['warning']({
          message: 'Er ging iets fout met het ophalen van de actie status trackers.'
        })
      } finally {
        this.loadingGroupActionTrackers = false;
      }
    },
    addListener(tracker) {
      let channelName = 'private-tenant.' + window.state.tenant.hash_id + '.group-action-tracker.' + tracker.id;
      let channel = this.$pusher.subscribe(channelName);
      channel.bind('tracker_updated', (status) => {
        tracker.processed_count = status.processed_count;
        tracker.failed_count = status.failed_count;

        if (tracker.count === tracker.processed_count) {
          this.trackerHasFinished(tracker);
        }
      });
    },
    initializePusher() {
      let newTrackersChannel = this.$pusher.subscribe('private-tenant.' + window.state.tenant.hash_id + '.search.' + this.searchId + '.group-action-trackers');

      newTrackersChannel.bind('tracker_created', (tracker) => {
        this.groupActionTrackers.unshift(tracker);
        this.addListener(tracker);
      });

      this.groupActionTrackers.forEach(this.addListener)
    },
    async trackerHasFinished(tracker) {
      let response = await groupActionApi.getTracker(tracker.id);

      this.$set(tracker, 'class_ids_for_failed_actions', response.data.class_ids_for_failed_actions)
      this.$set(tracker, 'class_ids_for_successful_actions', response.data.class_ids_for_successful_actions)
    }
  },
  computed: {
    getActiveTrackers() {
      return this.groupActionTrackers.filter(tracker => tracker.count === 0 || tracker.count !== tracker.processed_count);
    },
    getFinishedTrackers() {
      return this.groupActionTrackers.filter(tracker => tracker.count > 0 && tracker.count === tracker.processed_count);
    }
  }
}
</script>

<style scoped>
.ant-list-item-meta {
  width: 100%;
}
</style>
